import LookupsTypes from './LookupsTypes';

export const getTaxTypes = (payload) => ({
  type: LookupsTypes.GET_TAX_TYPES_TYPES,
  payload,
});
export const setTaxTypes = (payload) => ({
  type: LookupsTypes.SET_TAX_TYPES_TYPES,
  payload,
});

export const getPricingBasis = (payload) => ({
  type: LookupsTypes.GET_PRICING_BASIS,
  payload,
});
export const setPricingBasis = (payload) => ({
  type: LookupsTypes.SET_PRICING_BASIS,
  payload,
});

export const getPricingTypes = (payload) => ({
  type: LookupsTypes.GET_PRICING_TYPES,
  payload,
});
export const setPricingTypes = (payload) => ({
  type: LookupsTypes.SET_PRICING_TYPES,
  payload,
});

export const getMeasurementUnits = (payload) => ({
  type: LookupsTypes.GET_MEASUREMENT_UNIT_TYPES,
  payload,
});
export const setMeasurementUnits = (payload) => ({
  type: LookupsTypes.SET_MEASUREMENT_UNIT_TYPES,
  payload,
});

export const getLinerCodes = (payload) => ({
  type: LookupsTypes.GET_LINER_CODES,
  payload,
});
export const setLinerCodes = (payload) => ({
  type: LookupsTypes.SET_LINER_CODES,
  payload,
});

export const getGetPaymentTypes = (payload) => ({
  type: LookupsTypes.GET_PAYMENT_TYPES,
  payload,
});
export const setGetPaymentTypes = (payload) => ({
  type: LookupsTypes.SET_PAYMENT_TYPES,
  payload,
});

export const getVendorFieldsVisibility = (payload) => ({
  type: LookupsTypes.GET_VENDOR_FIELDS_VISIBILITY,
  payload,
});
export const setVendorFieldsVisibility = (payload) => ({
  type: LookupsTypes.SET_VENDOR_FIELDS_VISIBILITY,
  payload,
});
